goog.provide("shadow.js.shim.module$$carbon$icons_react$es$ChevronRight$default");
shadow.js.shim.module$$carbon$icons_react$es$ChevronRight$default = shadow.js.require(355, {}).default;
